import { useEffect } from "react";

export default function Download() {
  useEffect(() => {
    const link = document.createElement("a");
    link.href = "/app-debug.apk";
    link.download = "app-debug.apk";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }, []);

  return <h1>Your download eshould begin shortly...</h1>;
}
